import { MarketingChoice, MarketingInfo } from '../models/Order';

// The texts a prebooking's join page shows about offers, as the online booking does (Swedish, translated when
// shown), %s = who they come from
export const OFFERS_NOTICE = '%s skickar ibland erbjudanden och nyheter via e-post och sms till gäster som besökt oss.';
export const OFFERS_DECLINE = 'Nej tack, det vill jag inte ha.';
export const OFFERS_CONSENT = 'Ja tack, jag vill få erbjudanden och nyheter från %s via e-post och sms. Du kan avregistrera dig när som helst.';
// The texts the guest's page for a reservation shows about offers (Swedish, translated when shown), %s = who they
// come from: asking a guest who hasn't answered, and telling one who gets offers
export const OFFERS_ASK = 'Vill du ha erbjudanden och nyheter från %s via e-post och sms? Du kan avregistrera dig när som helst.';
export const OFFERS_RECEIVES = '%s skickar ibland erbjudanden och nyheter till dig via e-post och sms.';

// The box starts ticked with the guest's earlier no thanks
export function offersTickedAtStart(info: MarketingInfo | undefined): boolean {
  return info?.question === 'declined';
}

// The guest's answer to send, with the texts the guest saw. With the customer relationship exception the notice and
// the box: ticked, no thanks; unticked, told and didn't say no, or an earlier no thanks taken back. Without it the box
// is a yes, sent only when ticked. Nothing when there was no box (samwise didn't answer, or the guest already had the
// choice) or the guest kept an earlier no thanks.
export function bookingMarketing(info: MarketingInfo | undefined, ticked: boolean, notice: string,
                                 box: string): MarketingChoice | undefined {
  if (!info?.question) return undefined;
  if (!info.customer_relationship) return ticked ? { granted: true, objected: false, text: box } : undefined;
  const text = `${notice}\n${box}`;
  if (info.question === 'declined') {
    return ticked ? undefined : { granted: false, objected: false, objection_withdrawn: true, text };
  }
  return { granted: false, objected: ticked, text };
}
